<template>
  <div id="modalNoticeView" class="modal fade">
    <div
      class="modal-dialog modal-dialog-vertical-center modal-lg"
      role="document"
    >
      <div class="modal-content bd-0 tx-14">
        <div class="modal-header pd-y-20 pd-x-25">
          <h6 class="tx-14 mg-b-0 tx-uppercase tx-inverse tx-bold">
            {{ $t(noticeTypeArr[item.type]) }} / {{ item.title }}
          </h6>
          <button
            type="button"
            data-dismiss="modal"
            aria-label="Close"
            class="close"
          >
            <span aria-hidden="true">×</span>
          </button>
        </div>
        <div
          v-if="item.wxType == 1"
          class="modal-body pd-25"
          style="color: #343a40"
        >
          <div
            v-if="item.createUserId > 0"
            style="font-size: 16px; line-height: 30px"
            v-html="item.content"
          ></div>
          <div v-else v-html="item.content"></div>
        </div>
        <div v-else class="modal-body pd-25">
          <a :href="item.content" target="_blank"
            ><img :src="item.content" style="max-width: 750px"
          /></a>
        </div>
        <div class="modal-footer">
          <button
            type="button"
            class="
              btn btn-secondary
              tx-11 tx-uppercase
              pd-y-12 pd-x-25
              tx-mont tx-semibold
            "
            data-dismiss="modal"
          >
            {{ $t("dashboard.关闭") }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: ["item", "noticeTypeArr"],
};
</script>
